import React, { useEffect, useRef } from "react";
import { ReactComponent as GoogleMapIcon } from '../../images/GoogleMapIcon.svg';
import { ReactComponent as SatelliteMapIcon } from '../../images/SatelliteMapIcon.svg';
import { ReactComponent as StreetMapIcon } from '../../images/StreetMapIcon.svg';
import L from "leaflet";


const LayerDropdown = ({ onLayerChange, selectedLayer, onClose }) => {
  const dropdownRef = useRef(null);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      onClose(); // Close the dropdown if clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getBorderStyle = (layerName) =>
    selectedLayer === layerName ? "2px solid green" : "none";

  // Handle layer selection
  const handleLayerSelection = (layerName) => {
    onLayerChange(layerName); // Trigger the layer change callback
    onClose(); // Close the dropdown immediately after selection
  };

  return (
    <div
      ref={dropdownRef}
      style={{
        color: "black",
        position: "absolute",
        top: "20px",
        left: "80px",
        zIndex: 1000,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        borderRadius: "5px",
        padding: "10px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        fontFamily: "Poppins-thin, sans-serif",
      }}
    >
      {/* Street Layer */}
      <button
        onClick={() => handleLayerSelection("Street")}
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "9px",
          padding: "5px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
        }}
      >
        <GoogleMapIcon
          style={{
            border: getBorderStyle("Street"),
            borderRadius: "5px",
            padding: "4px",
          }}
        />
        <span
          style={{
            marginLeft: "8px",
            color: "black",
            fontSize: "14px",
            fontFamily: "Poppins-thin,sans-serif",
          }}
        >
          Street
        </span>
      </button>

      {/* Satellite Layer */}
      <button
        onClick={() => handleLayerSelection("Satellite")}
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "5px",
          padding: "5px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
        }}
      >
        <SatelliteMapIcon
          style={{
            border: getBorderStyle("Satellite"),
            borderRadius: "5px",
            padding: "4px",
          }}
        />
        <span
          style={{
            marginLeft: "8px",
            color: "black",
            fontSize: "14px",
            fontFamily: "Poppins-thin,sans-serif",
          }}
        >
          Satellite
        </span>
      </button>

      {/* OpenStreetMap Layer */}
      <button
        onClick={() => handleLayerSelection("OpenStreetMap")}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px",
          cursor: "pointer",
          background: "transparent",
          border: "none",
        }}
      >
        <StreetMapIcon
          style={{
            border: getBorderStyle("OpenStreetMap"),
            borderRadius: "5px",
            padding: "4px",
          }}
        />
        <span
          style={{
            marginLeft: "8px",
            color: "black",
            fontSize: "14px",
            fontFamily: "Poppins-thin,sans-serif",
          }}
        >
          OpenStreetMap
        </span>
      </button>
    </div>
  );
};

export default LayerDropdown;
